import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// -------------------------------------------------------------------------
// Indian numbering → words. Used on tax invoices to spell out grand totals
// ("Rupees One Thousand One Hundred Eighteen Only") per GST conventions.
// -------------------------------------------------------------------------
const _ONES = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine",
  "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen",
  "Seventeen", "Eighteen", "Nineteen"];
const _TENS = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

function _twoDigitWords(n) {
  n = Math.floor(n);
  if (n < 20) return _ONES[n];
  const t = Math.floor(n / 10);
  const u = n % 10;
  return u === 0 ? _TENS[t] : `${_TENS[t]} ${_ONES[u]}`;
}

function _threeDigitWords(n) {
  n = Math.floor(n);
  const h = Math.floor(n / 100);
  const rest = n % 100;
  const parts = [];
  if (h) parts.push(`${_ONES[h]} Hundred`);
  if (rest) parts.push(_twoDigitWords(rest));
  return parts.join(" ");
}

export function amountInWords(amount, currency = "Rupees") {
  const num = Math.abs(Math.round(Number(amount) || 0));   // paise-rounded
  if (num === 0) return `${currency} Zero Only`;
  const crore = Math.floor(num / 10000000);
  const lakh = Math.floor((num % 10000000) / 100000);
  const thou = Math.floor((num % 100000) / 1000);
  const rest = num % 1000;
  const parts = [];
  if (crore) parts.push(`${_twoDigitWords(crore)} Crore`);
  if (lakh) parts.push(`${_twoDigitWords(lakh)} Lakh`);
  if (thou) parts.push(`${_twoDigitWords(thou)} Thousand`);
  if (rest) parts.push(_threeDigitWords(rest));
  const words = parts.join(" ").replace(/\s+/g, " ").trim();
  return `${currency} ${words} Only`;
}
